import styled, { css } from 'styled-components';

import { Button } from '@/shared/components/button';

export const CopyButton = styled(Button)<{ $isCopied: boolean }>`
  height: 54px;
  line-height: 21.6px;
  font-size: 18px;
  font-weight: 600;
  width: 100%;
  margin-top: 10px;

  ${(props) =>
    props.$isCopied &&
    css`
      background: #ffa582;

      &:hover {
        background: #ffa582;
      }

      &:active {
        background: #ffa582;
      }
    `}
`;
